import { Dayjs } from 'dayjs'

// Answer state types - including arrays for checkbox/multi-select fields
export type FieldValue =
  | string
  | number
  | boolean
  | Dayjs
  | string[]
  | null
  | undefined
export type AnswerState = Record<string /* item.id */, FieldValue>

// Answer actions
export type AnswerAction =
  | { type: 'SET'; id: string; value: FieldValue }
  | { type: 'SET_ALL'; payload: AnswerState }
  | { type: 'RESET' }
  | { type: 'INIT_STATE'; payload: AnswerState }
  | { type: 'PREFILL'; payload: AnswerState }

/**
 * 🔄 answersReducer: Manages dynamic form answers state
 *
 * @param state - Current answers state
 * @param action - Action to perform on the state
 * @returns Updated answers state
 */
export const answersReducer = (
  state: AnswerState,
  action: AnswerAction
): AnswerState => {
  console.log('🔄 answersReducer: Processing action', {
    type: action.type,
    action,
  })

  switch (action.type) {
    case 'SET':
      return { ...state, [action.id]: action.value }
    case 'SET_ALL':
      return { ...action.payload }
    case 'RESET':
      return {}
    case 'INIT_STATE':
      console.log(
        '🔄 answersReducer: Initializing state with prefilled answers',
        {
          payloadKeys: Object.keys(action.payload),
          payloadCount: Object.keys(action.payload).length,
        }
      )
      return { ...action.payload }
    case 'PREFILL':
      console.log(
        '🔄 answersReducer: Prefilling form with existing player data',
        {
          payloadKeys: Object.keys(action.payload),
          payloadCount: Object.keys(action.payload).length,
          existingAnswers: Object.keys(state).length,
        }
      )
      return { ...state, ...action.payload }
    default:
      return state
  }
}
